import * as React from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

import * as Styles from "../../QuestionDialog.styles"

export const SortableChoice: React.FC<SortableChoiceProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id: props.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.ChoiceRow
      ref={setNodeRef}
      style={style}
    >
      <Styles.DragIcon
        {...attributes}
        {...listeners}
      />

      <Styles.ChoiceInput
        value={props.choice}
        onChange={event => props.onChange(props.index, event.target.value)}
        disabled={props.isLoading}
      />

      {props.canRemove && (
        <Styles.DeleteChoiceButton
          type="button"
          onClick={() => props.onRemove(props.index)}
          disabled={props.isLoading}
        >
          ×
        </Styles.DeleteChoiceButton>
      )}
    </Styles.ChoiceRow>
  )
}

export interface SortableChoiceProps {
  id: string,
  index: number,
  choice: string,
  canRemove: boolean,
  onChange: (index: number, value: string) => void,
  onRemove: (index: number) => void,
  isLoading?: boolean,
}
